import { DEAL_DOC_ACCEPT_FORMATS } from "@config/constants";
import { IEmailAttachment } from "@interfaces/email.interface";

// When status is undefined, falls back to document presence check for legacy API responses
export const isAttachmentPending = (a: IEmailAttachment): boolean =>
  a.status === "pending" || (!a.status && !a.document);

export const isAttachmentFailed = (a: IEmailAttachment): boolean =>
  a.status === "failed";

export const isAttachmentCompleted = (a: IEmailAttachment): boolean =>
  a.status === "completed" || (!a.status && !!a.document);

export const allAttachmentsSettled = (attachments: IEmailAttachment[]): boolean =>
  attachments.length === 0
  || attachments.every(a => isAttachmentCompleted(a) || isAttachmentFailed(a));

export const isSupportedDealDocAttachment = (a: IEmailAttachment): boolean =>
  !!a.format && DEAL_DOC_ACCEPT_FORMATS.includes(a.format.toLowerCase());
